import styled from "styled-components";

export const StyledModalOverlay = styled.div`
  align-items: center;
  backdrop-filter: blur(1px);
  background-color: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 11;
`;

export const StyledModalT1 = styled.div`
  background-color: white;
  border-radius: 4px;
  border: 1px solid var(--PEARL, #ecf1f4);
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05));
  font-family: Inter;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  left: 0;
  line-height: 22px;
  margin: 5vh auto;
  position: absolute;
  right: 0;
  width: 35vw;
  z-index: 12;
  min-width: ${({ $minWidth }) => $minWidth}px;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
`;

export const StyledLabelForConfirm = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 9px;
  border-radius: 4px;
  background: #f5f6f8;
  margin-top: 8px;
`;

export const StyledConfirmMatch = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
  color: #4a4a68;
  font-size: 13px;

  input {
    border: 1px solid #d5d8e0;
    border-radius: 6px;
    font-size: 14px;
    height: 36px;
    padding: 0 10px;
  }
`;
export const StyledModalContent = styled.div`
  color: var(--DARK-GREY, #0e0e2c);
  font-size: 14px;
  line-height: 22px;
  padding: 16px;
  padding-bottom: 0;
`;
